import { HelpersModule } from "../helpers/helpers";
import SameHeight from 'same-height';

const helpersModule = new HelpersModule();

export class HowCanWeHelpModule {

    constructor() {
        this.init();
    }

    isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    }

    setupHospitalDropdown() {
        var ajaxUrl = apilocation + "Finders/SuggestHospitals/";
        var html = "";
        fetch(ajaxUrl)
            .then(function (response) {
                response.json().then(data => ({
                    data: data,
                    status: response.status
                })
                ).then(res => {
                    if (res.status == 500) {
                        return;
                    }
                    var data = JSON.parse(res.data);
                    $.each(data.Suggestions, function (index, item) {
                        html += "<li data-value='" + item.NodeId + "'>" + item.Display + "</li>";
                    });
                    $("#hospitalDropdown .results").append(html);

                    var hospitalId = $("body").data("hospital-id");
                    var hospitalName = $("body").data("hospital-name");
                    $("#hospitalDropdown .dropdown-toggle:first-child").text(hospitalName);
                    $("#hospitalDropdown .dropdown-toggle:first-child").val(hospitalId);
                    
                });
            });
    }

    setupTreatmentDropdown() {
        var selectedHospitalId = $("#treatmentDropdown .dropdown-toggle:first-child").val();
        var tfilter = "";
        if (selectedHospitalId == '' || selectedHospitalId == 0) {
            selectedHospitalId = $("body").data("hospital-id");
        }
        if (selectedHospitalId > 0) {
            tfilter = selectedHospitalId > 0 ? "?filterByHospital=" + selectedHospitalId : "";
        }
        var ajaxUrl = apilocation + "Finders/SuggestTreatments/" + tfilter;
        var html = "";
        fetch(ajaxUrl)
            .then(function (response) {
                if (response.status == 500) {
                    return;
                }
                response.json().then(data => ({
                    data: data,
                    status: response.status
                })
                ).then(res => {
                    //if (res.status == 200) {
                    //    return;
                    //}
                    if (res.data !== null) {
                        var data = JSON.parse(res.data);
                        $.each(data.Suggestions, function (index, item) {
                            html += "<li data-value='" + item.NodeId + "'>" + item.Display + "</li>";
                        });
                        $("#treatmentDropdown .results").append(html);
                    }                  
                });
            });
    }

    setupSpecialityDropdown() {
        var selectedHospitalId = $("#specialityDropdown .dropdown-toggle:first-child").val();
        var sfilter = "";
        if (selectedHospitalId == '' || selectedHospitalId == 0) {
            selectedHospitalId = $("body").data("hospital-id");
        }
        if (selectedHospitalId > 0) {
            sfilter = selectedHospitalId > 0 ? "?filterByHospital=" + selectedHospitalId : "";
        }
        var ajaxUrl = apilocation + "Finders/SuggestSpecialties/" + sfilter;
        var html = "";
        console.log(ajaxUrl);
        fetch(ajaxUrl)
            .then(function (response) {
                if (response.status == 500) {
                    return;
                }
                response.json().then(data => ({
                    data: data,
                    status: response.status
                })
                ).then(res => {
                    var data = JSON.parse(res.data);
                    $.each(data.Suggestions, function (index, item) {
                        html += "<li data-value='" + item.NodeId + "'>" + item.Display + "</li>";
                    });
                    $("#specialityDropdown .results").append(html);
                });
            });
    }

    handleRadioChange() {
        $("input[type=radio][name='hospital-search']").on('change',function () {
            if (this.value == "speciality") {
                $("#treatmentDropdown").hide();
                $("#specialityDropdown").show();
            }
            else {
                $("#specialityDropdown").hide();
                $("#treatmentDropdown").show();
            }
        });
    }

    registerDropdownClicks() {
        $("#hospitalDropdown .results").on("click", "li", function (event) {
            $("#hospitalDropdown .dropdown-toggle:first-child").text($(this).text());
            $("#hospitalDropdown .dropdown-toggle:first-child").val($(this).data("value"));
        });

        $("#treatmentDropdown .results").on("click", "li", function (event) {
            $("#treatmentDropdown .dropdown-toggle:first-child").text($(this).text());
            $("#treatmentDropdown .dropdown-toggle:first-child").val($(this).data("value"));
        });

        $("#specialityDropdown .results").on("click", "li", function (event) {
            $("#specialityDropdown .dropdown-toggle:first-child").text($(this).text());
            $("#specialityDropdown .dropdown-toggle:first-child").val($(this).data("value"));
        });

    }

    resetClick() {

        $("#component-home-introduction-reset").on("click", function (e) {

            e.preventDefault();

            $("#component-home-introduction-postcode").val("");

            $("#hospitalDropdown .dropdown-toggle:first-child").text("Hospital");
            $("#hospitalDropdown .dropdown-toggle:first-child").val("");

            $("#treatmentDropdown .dropdown-toggle:first-child").text("Treatment");
            $("#treatmentDropdown .dropdown-toggle:first-child").val("");

            $("#specialityDropdown .dropdown-toggle:first-child").text("Speciality");
            $("#specialityDropdown .dropdown-toggle:first-child").val("");

            $("#component-home-introduction-treatment").prop("checked", true);
            $("#specialityDropdown").hide();
            $("#treatmentDropdown").show();

        });

    }

    searchClick() {

        $("#component-home-introduction-search").on("click", function (e) {

            e.preventDefault();
            var url = "/consultants/profiles/";
            var filterString = "?filterByTreatment=&filterBySpecialty=";
            var consultantRadioButtonValue = $("input[name='hospital-search']:checked").val();

            if (consultantRadioButtonValue == "treatment") {
                //var val = $("#treatmentDropdown .dropdown-toggle:first-child").val();
                var val = $("#treatmentDropdown").find(".dropdown-toggle").val();
                filterString = "?filterByTreatment=" + val + "&filterBySpecialty=";
            }
            else if (consultantRadioButtonValue == "speciality") {
                //var val = $("#specialityDropdown .dropdown-toggle:first-child").val();
                var val = $("#specialityDropdown").find(".dropdown-toggle").val();
                filterString = "?filterByTreatment=&filterBySpecialty=" + val;
            }
            //var hosVal = $("#hospitalDropdown .dropdown-toggle:first-child").val();
            var hosVal = $("#hospitalDropdown").find(".dropdown-toggle").val();
            var postcode = $("#component-home-introduction-postcode").val();
            filterString += "&filterByHospital=" + hosVal;
            filterString += "&filterByName=&filterByPostCode=" + postcode + "&filterByBookable=false";
            window.location = url + filterString;
        });
    }

    navigation() {
        
        $(".component-home-introduction").hide();

        $("#component-home-introduction").on('click', '.js-home-introduction--menu-item', function (e) {
            e.preventDefault();
            var panelRqst = $(this)[0].getAttribute("value");
            $(".component-home-introduction").hide();
            $("#component-home-introduction--" + panelRqst).show();
        });

        $("#component-home-introduction").on('click', '.js-home-introduction__panel', function (e) {
            e.preventDefault();
            var panelRqst = $(this).data("value");
            $("#component-home-introduction--home").hide();
            $("#component-home-introduction--" + panelRqst).show();
        });

    }

    setupFilter() {
        $("#hospitalSearch").on("keyup", function () {
            var value = $(this).val().toLowerCase();
            $(".dropdown-menu-hospital > li> ul > li").filter(function () {
                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
            });
        });

        $("#treatmentSearch").on("keyup", function () {
            var value = $(this).val().toLowerCase();
            $(".dropdown-menu-treatment > li> ul > li").filter(function () {
                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
            });
        });

        $("#specialitySearch").on("keyup", function () {
            var value = $(this).val().toLowerCase();
            $(".dropdown-menu-speciality > li> ul > li").filter(function () {
                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
            });
        });
    }

    equalHeights() {
        SameHeight.init(".home-introduction__panel-lead", "screen and (min-width: 992px)");
    }

    init() {
        $("#component-home-introduction-treatment").prop("checked", true);
        $("#treatmentDropdown").show();
        this.setupHospitalDropdown();
        this.setupTreatmentDropdown();
        this.setupSpecialityDropdown();
        this.handleRadioChange();
        this.registerDropdownClicks();
        this.resetClick();
        this.searchClick();
        this.navigation();
        this.setupFilter();
        this.equalHeights();
    }
}
